if (!customElements.get('product-set-add-all')) {
  class ProductSetAddAll extends HTMLElement {
    connectedCallback() {
      this.sectionRoot = this.closest('.product-set-slider-root');
      this.button = this.querySelector('button[type="button"]');
      this.labelTemplate = this.dataset.labelTemplate || '';
      this.soldOutLabel = this.dataset.soldOutLabel || '';
      this.boundUpdate = this.updateButton.bind(this);
      if (this.button) {
        this.button.addEventListener('click', this.onClick.bind(this));
      }
      this.bindSlides();
      this.updateButton();
    }

    disconnectedCallback() {
      this.unbindSlides();
    }

    bindSlides() {
      this.unbindSlides();
      this.slides = this.sectionRoot ? Array.from(this.sectionRoot.querySelectorAll('.product-set-slide-inner')) : [];
      this.slides.forEach((slide) => {
        slide.querySelectorAll('.inline-swatch-group input').forEach((input) => {
          input.addEventListener('change', this.boundUpdate);
        });
      });
    }

    unbindSlides() {
      if (!this.slides) {
        return;
      }
      this.slides.forEach((slide) => {
        slide.querySelectorAll('.inline-swatch-group input').forEach((input) => {
          input.removeEventListener('change', this.boundUpdate);
        });
      });
      this.slides = null;
    }

    getProductData(slide) {
      const script = slide.querySelector('[data-product-json]');
      if (!script || !script.textContent) {
        return null;
      }
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return null;
      }
    }

    getVariantIdFromSlide(slide) {
      const card = slide.querySelector('product-card');
      const swatchInput = card ? card.querySelector('.inline-swatch-group input:checked') : null;
      if (swatchInput && swatchInput.dataset.variantId) {
        return swatchInput.dataset.variantId / 1;
      }
      if (swatchInput && swatchInput.dataset.variantUrl) {
        try {
          const variantParam = new URL(swatchInput.dataset.variantUrl, window.location.origin).searchParams.get('variant');
          if (variantParam) {
            return variantParam / 1;
          }
        } catch (e) {
          /* ignore malformed url */
        }
      }
      if (slide.dataset.defaultVariantId) {
        return slide.dataset.defaultVariantId / 1;
      }
      return null;
    }

    getVariantFromSlide(slide) {
      const productData = this.getProductData(slide);
      if (!productData || !productData.variants) {
        return null;
      }
      const variantId = this.getVariantIdFromSlide(slide);
      if (variantId) {
        return productData.variants.find((variant) => variant.id === variantId) || null;
      }
      return productData.variants.find((variant) => variant.available) || productData.variants[0] || null;
    }

    buildLineItems() {
      const items = [];
      let allAvailable = true;
      this.slides.forEach((slide) => {
        const variant = this.getVariantFromSlide(slide);
        if (!variant || !variant.available) {
          allAvailable = false;
          return;
        }
        items.push({ id: variant.id, quantity: 1 });
      });
      if (items.length !== this.slides.length) {
        allAvailable = false;
      }
      return { items, allAvailable };
    }

    getTotalCents() {
      let total = 0;
      let allAvailable = true;
      this.slides.forEach((slide) => {
        const variant = this.getVariantFromSlide(slide);
        if (!variant || !variant.available) {
          allAvailable = false;
          return;
        }
        total += variant.price;
      });
      if (this.slides.length === 0) {
        allAvailable = false;
      }
      return { total, allAvailable };
    }

    formatTotal(cents) {
      return $s.formatMoney($s.toCartCurrency(cents)).replace('.00', '');
    }

    updateButton() {
      if (!this.button) {
        return;
      }
      const { total, allAvailable } = this.getTotalCents();
      if (!allAvailable) {
        this.button.textContent = this.soldOutLabel || this.labelTemplate.replace('[total]', '');
        this.button.disabled = true;
        return;
      }
      this.button.textContent = this.labelTemplate.replace('[total]', this.formatTotal(total));
      this.button.disabled = false;
    }

    onClick(event) {
      event.preventDefault();
      const { items, allAvailable } = this.buildLineItems();
      if (!allAvailable || !items.length) {
        return;
      }
      $s.showLoadingOverlay();
      $s.post({
        url: routes.cart_url + '/add.js',
        data: { items: items },
        success: () => {
          $s.addToCartSuccess();
        },
        error: (response) => {
          $s.addToCartFail(response.description);
        },
        always: () => {
          $s.hideLoadingOverlay();
        }
      });
    }
  }
  customElements.define('product-set-add-all', ProductSetAddAll);
}
